import React from "react";

export function BrutalCard({ className = "", children, color, ...props }) {
  const bg = color || "bg-white";
  return (
    <div className={`brutal brutal-hover ${bg} ${className}`} {...props}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, color = "bg-white", icon, testid }) {
  return (
    <div className={`brutal brutal-hover ${color} p-6`} data-testid={testid}>
      <div className="flex items-start justify-between">
        <div className="text-xs font-bold uppercase tracking-widest text-neutral-700">{label}</div>
        {icon && <div className="text-black">{icon}</div>}
      </div>
      <div className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-2 leading-none break-words">{value}</div>
      {sub && <div className="text-xs mt-2 text-neutral-700 font-medium">{sub}</div>}
    </div>
  );
}

export function Chip({ children, color = "bg-white" }) {
  return <span className={`chip ${color}`}>{children}</span>;
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl xl:text-6xl leading-[1.02] tracking-tight">{title}</h1>
        {subtitle && <p className="mt-2 sm:mt-3 text-neutral-700 text-sm sm:text-base md:text-lg max-w-2xl">{subtitle}</p>}
      </div>
      {right && <div className="flex flex-wrap gap-3">{right}</div>}
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="brutal p-10 text-center">
      <div className="mx-auto w-16 h-16 bg-brand-yellow border-2 border-black rounded-2xl flex items-center justify-center mb-4 shadow-brutal">
        <span className="font-display font-black text-2xl">!</span>
      </div>
      <div className="font-display font-black text-2xl">{title}</div>
      {description && <div className="text-neutral-700 mt-2 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
  );
}
